import React from "react";
import "./styles.css";

const Button = ({ label, iconLeft, name, click }) => {
  return (
    <button type="button" className="buttonK" onClick={(e) => click(name, "")}>
      <span>
        <i className={`fa ${iconLeft}`}></i>
        <span
          style={{
            paddingLeft:
              iconLeft === "fa-clipboard" ||
              iconLeft === "fa-check" ||
              iconLeft === "fa-refresh"
                ? "7.5px"
                : "",
          }}
        >
          {label}
        </span>
        {iconLeft === "fa-file-text-o" && <i className="fa fa-angle-right"></i>}
      </span>
    </button>
  );
};

export default Button;
